<script>
import Icon from './icon';

export default {
  components: {
    Icon
  },

  props: {
    note: null
  }
}
</script>

<template lang="html">
  <div class="Note">
    <p class="Note-title">{{ note.title }}</p>
    <p class="Note-date">{{ note.created_at }}</p>
    <p v-if="note.status == 'pending'" class="Note-status">Pending Approval</p>
    <p v-if="note.status != 'personal'" class="Note-author u-mb1">Added by {{ note.author_name }}</p>
    <div class="u-richtext u-richtext--scale u-mt1">
      <p>{{ note.body }}</p>
    </div>
    <ul class="AttachmentListing u-mt3" v-if="!!note.attachments.edges.length">
      <li class="AttachmentListing-item" v-for="(attachmentNode, index) in note.attachments.edges">
        <a class="Attachment Button Button--outline" v-bind:href="attachmentNode.node.url">
          {{ attachmentNode.node.filename }}
          <span class="Attachment-meta">{{ attachmentNode.node.file_size }}</span>
          <icon icon="download"></icon>
        </a>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// note.vue?159a55c4